<template>
    <ul class="pagination-list">
        <li
            v-for="(page, index) in pages"
            :key="index"
        >
            <a
                class="pagination-link"
                :class="{'is-current': page == pageInfo.currentPage, 'has-background-white': page != pageInfo.currentPage}"
                @click="setPage(page)"
            >
                {{ page }}
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        pageInfo: {
            type: Object,
            required: true,
        }
    },
    methods: {
        setPage(page) {
            this.$emit('update:page', page);
        }
    },
    emits: [
        'update:page'
    ],
    computed: {
        pages() {
            const pages = [];
            for (let i = 1; i <= this.pageInfo?.lastPage; i++) {
                pages.push(i);
            }
            return pages;
        }
    }
}
</script>
